<template>
  <!--<BasicLayout :left='left' :middle='middle' :right='right'>-->
    <!--<template v-slot:left_view>
      &lt;!&ndash;<NeList ref='neInfo' :neArr='netype' :select='neClick' name="selectNeTree"></NeList>&ndash;&gt;
    </template>-->
    <!--<template v-slot:right_view>-->
  <div>
    <DPEnviromentTableMenu @methodEnum='methodEnum' @keywords='changeKeywords'></DPEnviromentTableMenu>
    <DPEnviromentTable ref="dpEnviromentTable"></DPEnviromentTable>
  </div>
   <!-- </template>-->
  <!--</BasicLayout>-->
</template>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import DPEnviromentTableMenu from '../../../components/deploymentManagement/runningEnvironment/DPEnviromentConfig/DPEnviromentTableMenu';
import DPEnviromentTable from '../../../components/deploymentManagement/runningEnvironment/DPEnviromentConfig/DPEnviromentTable';

export default {
  name: 'runingEnviromentListPage',
  components: {
    BasicLayout,
    DPEnviromentTableMenu,
    DPEnviromentTable
  },
  data() {
    return {
      left: {
        show: true,
        name: '运行环境'// this.$t('UE.neList')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: 'POC-DP'// this.$t('UE.ueTraffic')
      }
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'addDP':
          this.$refs.dpEnviromentTable.addDPEnviroment();
          break;
        case 'delDP':
          this.$refs.dpEnviromentTable.delDPEnviroment();
          break;
        case 'deploy':
          this.$refs.dpEnviromentTable.getDeployTemplate();
          break;
        case 'detail':
          this.$refs.dpEnviromentTable.getDeployInstance();
          break;
        case 'export':
          this.$refs.dpEnviromentTable.exportDpTemplate();
          break;
        default:
      }
    },
    changeKeywords(args) {
      //this.$refs.ueTable.queryConditions.keywords = args;
    }
  }
};
</script>

<style scoped>

</style>
